import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectSelectedTimeline } from "_redux/slices/timeline/timeline-areas";
import { setShowTimelineSidebar, setTimeLineDate, selectTimelineDate, resetTimelineSlots } from "_redux/slices/timeline/timeline-control";
import { selectOpenBroadcastMessages, setOpenBroadcastMessages } from "_redux/slices/timeline/employees";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";

// styling
import { Colors, Spacing } from "_styles";

// icons
import { IoOptions, IoSettingsOutline, IoChatbubble, IoCalendarOutline, IoLocationSharp, IoListOutline } from "react-icons/io5";

// utils
import { getDate } from "_utils/functions";

// Phones hide TimelineTitles, so its header controls (control panel, locations, broadcast
// messages, JER's tomorrow toggle) are collected here. Reports stay desktop-only.
// onToggleLocations swaps the bottom job list for the airport locations panel.
const PhoneOptionsMenu = ({ showLocations, onToggleLocations }) => {
    const dispatch = useDispatch();

    const selectedTimeline = useSelector(selectSelectedTimeline);
    const timelineDate = useSelector(selectTimelineDate);
    const openBroadcastMessages = useSelector(selectOpenBroadcastMessages);
    const dbUser = useSelector(selectFirebaseInfo);

    // same rules as TimelineTitles: Jersey-only forward planning
    const canChangeDate = dbUser.details.authority === "JER";
    const viewingToday = getDate(timelineDate) === getDate(new Date());

    const handleToggleDay = () => {
        if (viewingToday) {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            dispatch(setTimeLineDate(tomorrow));
        } else {
            dispatch(setTimeLineDate(new Date()));
            dispatch(resetTimelineSlots({ authority: dbUser.details.authority }));
        }
    };

    return (
        // fixed popper: the toolbar sits in an overflow-hidden card that would clip the menu
        <Dropdown align="end" style={{ flexShrink: 0 }}>
            <Dropdown.Toggle as={OptionsToggle} />
            <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} style={{ zIndex: 1050, minWidth: 220 }}>
                <Dropdown.Header style={{ color: Colors.PRM_LIGHT_BLUE, fontWeight: 700 }}>
                    {selectedTimeline?.title ?? "All Airport View"}
                </Dropdown.Header>
                <Dropdown.Item onClick={() => dispatch(setShowTimelineSidebar(true))} style={itemStyle}>
                    <IoSettingsOutline size={18} color={Colors.PRM_LIGHT_BLUE} /> Control Panel
                </Dropdown.Item>
                {onToggleLocations && (
                    <Dropdown.Item onClick={onToggleLocations} style={itemStyle}>
                        {showLocations
                            ? <><IoListOutline size={18} color={Colors.PRM_LIGHT_BLUE} /> Show Jobs</>
                            : <><IoLocationSharp size={18} color={Colors.PRM_LIGHT_BLUE} /> Show Airport Locations</>}
                    </Dropdown.Item>
                )}
                <Dropdown.Item onClick={() => dispatch(setOpenBroadcastMessages(!openBroadcastMessages))} style={itemStyle}>
                    <IoChatbubble size={18} color={Colors.PRM_LIGHT_BLUE} /> Broadcast Messages
                </Dropdown.Item>
                {canChangeDate && (
                    <Dropdown.Item onClick={handleToggleDay} style={itemStyle}>
                        <IoCalendarOutline size={18} color={Colors.PRM_LIGHT_BLUE} /> {viewingToday ? "View Tomorrow" : "Back to Today"}
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

// icon button in place of bootstrap's caret toggle
const OptionsToggle = React.forwardRef(({ onClick, 'aria-expanded': expanded }, ref) => (
    <button
        ref={ref}
        type="button"
        onClick={onClick}
        aria-label="Timeline options"
        aria-expanded={expanded}
        style={toggleStyle}
    >
        <IoOptions size={22} />
    </button>
));

const toggleStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: Spacing.SCALE_38,
    height: Spacing.SCALE_38,
    padding: 0,
    border: '1px solid #307FE2',
    borderRadius: 6,
    color: '#307FE2',
    backgroundColor: '#fff',
};

const itemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 16px',
};

export default PhoneOptionsMenu;
